import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ContactSection from "@/components/ContactSection";
import SEO from "@/components/SEO";
import { Flame, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import bannerImage from "@/assets/pellet-banner.jpg";

const PelletCombustibili = () => {
  const products = [
    {
      name: "Pellet per Stufe certificato A1",
      description: "Pellet per stufe di altissima qualità certificato ENplus A1",
      features: ["Certificazione ENplus A1", "Basso contenuto di ceneri", "Alto potere calorifico", "Produzione italiana ed europea"]
    },
    {
      name: "Pellet per Stufe Faggio",
      description: "Pellet per stufe di faggio di alta qualità",
      features: ["100% faggio", "Lunga durata", "Alto potere calorifico", "Ceneri ridotte"]
    },
    {
      name: "Pellet per Stufe Conifera",
      description: "Pellet per stufe di conifere per un'ottima resa",
      features: ["Abete e conifera", "Eccellente combustione", "Ottimo rapporto qualità-prezzo", "Produzione certificata"]
    },
    {
      name: "Pellet per Stufe Abete",
      description: "Pellet per stufe di abete puro",
      features: ["100% abete", "Combustione uniforme", "Basso residuo", "Alta qualità"]
    },
    {
      name: "Consegna a domicilio",
      description: "Servizio di consegna comodo e veloce",
      features: ["Consegna a domicilio disponibile", "Programmazione forniture", "Assistenza clienti"]
    }
  ];

  return (
    <div className="min-h-screen">
      <SEO
        title="Pellet Certificato A1 Magione - Consegna Domicilio"
        description="Pellet certificato ENplus A1 per stufe: faggio, abete, conifera. Consegna a domicilio a Magione, Perugia e zona Trasimeno. Alto potere calorifico."
        keywords="pellet magione, pellet a1 perugia, pellet certificato trasimeno, pellet consegna domicilio umbria, pellet faggio magione"
        canonical="/prodotti/pellet-combustibili"
        type="product"
      />
      <Navbar />

      {/* Hero Banner Section */}
      <section className="relative h-[450px] md:h-[500px] overflow-hidden pt-24 md:pt-28">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${bannerImage})` }}
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />

        {/* Content */}
        <div className="relative container mx-auto px-4 h-full flex flex-col justify-start md:justify-center pt-2 md:pt-0">
          <Link to="/#prodotti" className="mb-6 w-fit">
            <Button variant="outline" className="bg-white/10 text-white border-white/30 hover:bg-white/20 backdrop-blur-sm">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Torna ai prodotti
            </Button>
          </Link>

          <div className="max-w-4xl">
            <div className="icon-wrapper mb-6 w-16 h-16 text-white hidden md:flex items-center justify-center">
              <Flame className="w-12 h-12" />
            </div>
            <h1 className="text-4xl md:text-5xl font-heading font-bold mb-6 text-white">
              Pellet per Stufe e Combustibili
            </h1>
            <p className="text-xl text-white/90 max-w-3xl">
              Pellet per stufe certificato, legna da ardere e bricchetti di qualità per il riscaldamento.
              Consegna a domicilio disponibile su tutta la zona.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid sm:grid-cols-2 lg:grid-cols-6 gap-6 max-w-7xl mx-auto">
            {products.map((product, index) => (
              <div
                key={index}
                className={`bg-card rounded-2xl p-8 border border-border card-hover ${
                  index < 3 ? "lg:col-span-2" : "lg:col-span-3"
                }`}
              >
                <h3 className="text-2xl font-heading font-semibold mb-4">
                  {product.name}
                </h3>
                <p className="text-muted-foreground mb-6">
                  {product.description}
                </p>
                <ul className="space-y-2">
                  {product.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-start">
                      <span className="text-primary mr-2">✓</span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 p-6 bg-orange-50 dark:bg-orange-950/20 border border-orange-200 dark:border-orange-800 rounded-xl max-w-4xl mx-auto">
            <h3 className="text-xl font-semibold mb-2 text-orange-900 dark:text-orange-100">
              🔥 Preparati per l'inverno
            </h3>
            <p className="text-orange-800 dark:text-orange-200">
              Ordina in anticipo il tuo pellet per stufe e la legna per la stagione invernale!
              Offriamo prezzi vantaggiosi per ordini stagionali e consegna programmata.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-primary/5">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-heading font-bold mb-4">
            Richiedi un preventivo
          </h2>
          <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
            Contattaci per ricevere un preventivo personalizzato e informazioni
            sulla consegna a domicilio nella tua zona.
          </p>
          <Link
            to="/#contatti"
            className="inline-block px-8 py-3 bg-primary text-primary-foreground rounded-lg hover:opacity-90 transition-opacity"
          >
            Contattaci
          </Link>
        </div>
      </section>

      <ContactSection />
      <Footer />
    </div>
  );
};

export default PelletCombustibili;
